import useSWR from 'swr'
import { api } from '@/lib/api'
import { FilterOptionsResponse } from '@/types'

export const useFilterOptions = () => {
  const { data, error, isLoading } = useSWR<FilterOptionsResponse>(
    'filter-options',
    () => api.getFilterOptions(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      dedupingInterval: 60000, // 1分間キャッシュ
      keepPreviousData: true,
    }
  )

  return {
    data,
    error,
    isLoading,
  }
}
